import { Api } from "./Api";
import { CorbeilleElement } from "../models/CorbeilleElement";
import _ from "lodash";
import axios from "axios";

export class CorbeilleApi extends Api {
    constructor() {
        super("corbeille");
    }

    getAll(params?: Object): Promise<Api.CallResponse> {
        return this.getResources(params).then(function (response) {
            let res: Array<CorbeilleElement> = [];
            if (response.data && response.data.data) {
                res = _.map(response.data.data, function (d) {
                    return new CorbeilleElement(d);
                });
            }
            return {
                data: res,
                metadata: response.data.metadata,
                paginator: response.data.paginator,
            };
        });
    }

    get(id: Number): Promise<CorbeilleElement> {
        return this.getResource(id).then(function (response) {
            return new CorbeilleElement(response.data.data);
        });
    }

    restore(id: Number): Promise<CorbeilleElement> {
        return axios
            .post(this.apiUrl + id + "/restore")
            .then(function (response) {
                return new CorbeilleElement(response.data.data);
            });
    }

    delete(id: Number): Promise<CorbeilleElement> {
        return super.deleteResource(id).then(function (response) {
            return new CorbeilleElement(response.data.data);
        });
    }
}
